import AuthEndpoints from '@/features/auth/endpoints/auth';
import PaddleEndpoints from '@/features/subscription/endpoints/paddle';
import PaymentEndpoints from '@/features/subscription/endpoints/payment';
import UserEndpoints from '@/features/auth/endpoints/user';
import ToolsEndpoints from '@/features/tool/api/endpoints/tools';
import FeatureEndpoints from '../features/tool/api/endpoints/feature';
import PlanEndpoints from '@/features/subscription/endpoints/plan';
import ProcessEndpoints from '@/features/tool/api/endpoints/process';
import DownloadEndpoints from '@/features/tool/api/endpoints/download';

const EndpointManager = {
  auth: AuthEndpoints,
  features: FeatureEndpoints,
  paddle: PaddleEndpoints,
  payment: PaymentEndpoints,
  plan: PlanEndpoints,
  user: UserEndpoints,
  tools: ToolsEndpoints,
  process: ProcessEndpoints,
  download: DownloadEndpoints,
};

export default EndpointManager;
